import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { CustomQuestionsQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/QuestionnaireSectionProps";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";

import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";

import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import * as questionIds from "../consultationQuestions/questionIds";
import { sections } from "../consultation";

// eslint-disable-next-line max-len
const HealthSurveillanceConsultationUrinalysisSectionUnconnected: React.FunctionComponent<CustomQuestionsQuestionnaireSectionProps> = (props: CustomQuestionsQuestionnaireSectionProps) => {
    const questions = Object.values(props.questions || {});
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.Urinalysis}
        >
            {YesNoWithFollowUpQuestion({
                readonly: props.readonly,
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.UrinalysisUnableToCarryOut),
                    getQuestionConfig(props.questionConfigs, questionIds.UrinalysisUnableToCarryOutReason)
                ],
                mandatory: true,
                followUpMandatory: true,
                questions: props.questions
            })}
            {getAnswerToQuestionWithId(questions, questionIds.UrinalysisUnableToCarryOut) !== MultiButtonQuestion.YesOption && <>
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.UrinalysisProtein)}
                    mandatory
                    values={[
                        "Positive",
                        "Negative"
                    ]}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.UrinalysisGlucose)}
                    mandatory
                    values={[
                        "Positive",
                        "Negative"
                    ]}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.UrinalysisBlood)}
                    mandatory
                    values={[
                        "Positive",
                        "Negative"
                    ]}
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.UrinalysisSelfReferralLetterIssued)}
                    mandatory
                />
            </>}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceConsultationUrinalysisSection = connect(makeMapStateToQuestionnaireSectionProps(sections.Urinalysis.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceConsultationUrinalysisSectionUnconnected);
